import { SUSTAINABLE_CLASSIFICATIONS } from "../../core/components/Search/useFilters";

export const setSustainableClassificationLabel = (sc: SUSTAINABLE_CLASSIFICATIONS): string => {
  switch (sc) {
      case SUSTAINABLE_CLASSIFICATIONS.RBDL_GRBD: return 'Green';
      case SUSTAINABLE_CLASSIFICATIONS.RBDL_SOCI: return 'Social';
      case SUSTAINABLE_CLASSIFICATIONS.RBDL_SUST: return 'Sustainable';
  }
}